const fetchOptions = {
    mode: 'cors',
    headers: {
      'Access-Control-Allow-Origin':'*'
    }
}

const host = 'https://adasis-web-demo-staging.tilestream.net';
// const host = 'http://127.0.0.1:80';

function getAdasisResponse() {
    return fetch(host + '/api/adasis', fetchOptions)
                .then(response => response.json())
                .then(payload => ({ data: payload.data }))
}

function getEnhancedData() {  
    return fetch(host + '/api/data', fetchOptions)
                .then(response => response.json())
                .then(payload => ({ data: payload.data }))
}

export { getAdasisResponse, getEnhancedData }
